import { OlympusClient } from '@/OlympusClient'

export const deleteBlockHandler = async (sectionId: string): Promise<void> => {
  await OlympusClient.notifications.v1.templates.emails.sections.section.deleteEmailSection(
    { params: { sectionId } }
  )
}
